module.exports = __webpack_public_path__ + "img/installiOS1.26c6cbd5.png";